<template>
  <div v-if="loading" class="text-center mt-5 font-2xl text-muted">
    <i class="fal fa-spinner fa-spin" /> Test Process Form Data Loading...
  </div>
  <div v-else class="animated fadeIn">
    <basic-heading title="New Test Process" class="mb-3" />
    <permission-alert-gate :permissions="'add test process'">
      <template #gated-content>
        <test-process-form :test_workflow="test_workflow" @submit="submit" />
      </template>
    </permission-alert-gate>
  </div>
</template>

<script>
import Vue from "vue";
import VueNotifications from "vue-notifications";
import BasicHeading from "@/components/shared/BasicHeading";
import HeaderButtonGroup from "@/components/shared/headerbuttons/HeaderButtonGroup";
import PermissionAlertGate from "@/components/permission/PermissionAlertGate";
import TestProcessForm from "@/components/lab/testprocess/TestProcessForm";
import { notificationOptions } from "@/shared/toast-notification-options";
import { testProcessNotifications } from "@/shared/notifications";
import { LabRepositoryFactory } from "@/repositories/lab/LabRepositoryFactory";
import { getModel } from "@/shared/fetch-utils";

const TestProcessRepository = LabRepositoryFactory.get("testProcess");
const TestWorkflowRepository = LabRepositoryFactory.get("testWorkflow");

Vue.use(VueNotifications, notificationOptions);

export default {
  name: "TestProcessAdd",
  components: {
    BasicHeading,
    HeaderButtonGroup,
    PermissionAlertGate,
    TestProcessForm,
  },
  data() {
    return {
      loading: true,
      laboratory_id: this.$store.getters.getLaboratoryContext.id,
      test_workflow_id: this.$route.params.test_workflow_id || null,
      test_workflow: null,
    };
  },
  methods: {
    async init() {
      this.test_workflow_id &&
        (this.test_workflow = await getModel({
          model_type: "test_workflow",
          id: this.test_workflow_id,
          message: this.$bvToast,
        }));

      this.loading = false;
    },
    async submit(form_data) {
      try {
        const { data } = await TestProcessRepository.create({
          ...form_data,
          laboratory_id: this.laboratory_id,
        });

        form_data.sample_types.forEach(async (id) => {
          await TestWorkflowRepository.create({
            laboratory_id: this.laboratory_id,
            sample_type_id: id,
            test_process_id: data.id,
            order: 0,
          });
        });
        this.addSuccess();

        this.$router.push(`/test-workflows/${this.test_workflow_id}`);
      } catch ({ response }) {
        this.$bvToast.toast(response.data.error, {
          title: "Process creation Failed.",
          variant: "danger",
        });
      }
    },
  },
  created() {
    this.loading = true;

    this.init();
  },
  notifications: testProcessNotifications,
};
</script>
